// extracted by mini-css-extract-plugin
export default {"V2FormInputNoColon":"V2FormInputNoColon--d6FSN"};